import Yourdata from "./Yourdata";
const YourDataUnit={
     Yourdata
}
export default YourDataUnit